module.exports = __webpack_public_path__ + "img/冲压车间4.0a55549e.jpg";